import { globalHistory } from '@reach/router';
import store from '../store';

globalHistory.listen(() => {
  store.dispatch({
    type: 'NAVIGATE',
  });
});
